<img [src]="isDarkMode() ? logoDark() : logoLight()" alt="Logo" class="mx-auto w-auto h-[40px]" alt="Logo" />
